import { Link, useParams } from 'react-router-dom';
import { ArrowRight, ArrowLeft } from 'lucide-react';
import Seo, { breadcrumbLd } from '../components/Seo';
import { MaskedLines, FadeUp, Eyebrow } from '../components/motion';
import NotFound from './NotFound';
import { useT } from '../i18n/LangContext';
import { useContent } from '../data/useContent';

export default function BlogPostPage() {
  const { slug } = useParams();
  const t = useT();
  const { BLOG_POSTS } = useContent();
  const post = BLOG_POSTS.find((p) => p.slug === slug);
  if (!post) return <NotFound />;

  return (
    <>
      <Seo title={`${post.title} | Reverence Services`} description={post.excerpt} jsonLd={[breadcrumbLd(['Home', 'Blog', post.title])]} />
      <article className="bg-ink pb-28 pt-16 md:pt-24">
        <div className="container-site max-w-3xl">
          <Link data-testid="blog-back-link" to="/blog" className="inline-flex items-center gap-2 text-sm font-semibold text-silver transition-colors hover:text-gold">
            <ArrowLeft className="h-4 w-4" /> {t['bp.back']}
          </Link>
          <div className="mt-8">
            <Eyebrow>{post.category} · {post.date}</Eyebrow>
            <MaskedLines as="h1" className="mt-4 font-serif text-4xl font-semibold leading-[1.08] tracking-tight sm:text-5xl"
              lines={[{ text: post.title, cls: 'text-white' }]} />
          </div>
          <FadeUp delay={0.3}>
            <img src={post.img} alt={post.title} className="photo-treat mt-10 aspect-[16/8] w-full rounded-xl object-cover" loading="lazy" />
            <div className="mt-10 space-y-6">
              {post.body.map((b, i) => b.type === 'h'
                ? <h2 key={i} className="pt-4 font-serif text-3xl font-semibold text-gold">{b.text}</h2>
                : <p key={i} className="text-base leading-relaxed text-white/75">{b.text}</p>)}
            </div>
            <div className="mt-14 rounded-xl border border-gold/30 bg-gold/5 p-8 text-center">
              <h2 className="font-serif text-2xl font-semibold">{t['bp.ctaH2']}</h2>
              <p className="mt-2 text-sm text-silver">{t['bp.ctaP']}</p>
              <Link data-testid="blog-post-cta" to="/quote" className="gold-btn mt-5">{t['bp.cta']} <ArrowRight className="h-4 w-4" /></Link>
            </div>
          </FadeUp>
        </div>
      </article>
    </>
  );
}
